import useReveal from "../../hooks/useReveal";
import { IMAGES } from "../../lib/data";

// Marquee strip with brand values
export const Marquee = () => {
  const items = [
    "Plage privée",
    "Service midi & soir",
    "Activités nautiques",
    "Transats & parasols",
    "Bar & cocktails",
    "Famille bienvenue",
    "Cuisine méditerranéenne",
  ];

  return (
    <section
      data-testid="marquee"
      className="bg-zp-navy text-zp-cream py-6 overflow-hidden border-y border-zp-navyHover/30"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap">
        {[...items, ...items, ...items].map((item, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-serif italic text-2xl md:text-3xl">
              {item}
            </span>
            <span className="text-zp-lemon text-3xl">✶</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export const About = () => {
  const ref1 = useReveal();
  const ref2 = useReveal();

  return (
    <section
      id="apropos"
      data-testid="about-section"
      className="bg-zp-cream py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <div ref={ref1} className="lg:col-span-7 reveal relative">
            <div className="zoom-wrap aspect-[4/5] lg:aspect-[5/6] relative">
              <img
                src={IMAGES.about}
                alt="Zénith Plage — sous le parasol"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Striped accent */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 cabana-stripes-yellow hidden md:block z-0" />
            <div className="absolute -top-6 -right-6 w-24 h-24 cabana-stripes-blue hidden md:block z-0" />
          </div>

          {/* Text side */}
          <div ref={ref2} className="lg:col-span-5 reveal reveal-delay-2">
            <p className="overline text-zp-navy/60 mb-6 flex items-center gap-3">
              <span className="dot" /> Notre maison
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-zp-navy">
              Une plage privée,
              <br />
              <span className="italic font-light">une histoire de famille.</span>
            </h2>

            <div className="mt-10 space-y-6 text-zp-muted text-base md:text-lg leading-relaxed font-light">
              <p>
                Sur l'avenue de l'Évêché de Maguelone, face à la Méditerranée,
                Zénith Plage cultive depuis toujours cet art simple de bien
                recevoir. Des parasols rayés bleu et blanc, du sable chaud, une
                cuisine généreuse — et l'accueil chaleureux d'une vraie
                maison du Sud.
              </p>
              <p>
                Ici, on vient pour la journée, on prolonge à l'apéro, on reste
                pour dîner. Les enfants courent jusqu'à l'eau, les amis trinquent
                à l'heure dorée, et le coucher de soleil devient un rendez-vous.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-12 pt-10 border-t border-zp-line">
              <div data-testid="stat-1">
                <div className="font-serif text-4xl md:text-5xl text-zp-navy">30</div>
                <div className="overline text-[10px] text-zp-muted mt-2">
                  Ans d'existence
                </div>
              </div>
              <div data-testid="stat-2">
                <div className="font-serif text-4xl md:text-5xl text-zp-navy">8h–1h</div>
                <div className="overline text-[10px] text-zp-muted mt-2">
                  Tous les jours
                </div>
              </div>
              <div data-testid="stat-3">
                <div className="font-serif text-4xl md:text-5xl text-zp-navy">★★★</div>
                <div className="overline text-[10px] text-zp-muted mt-2">
                  Vue mer 180°
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
